// import React, { useState } from 'react';
// import Icon from '../../../../components/AppIcon';

// const ScoreBar = ({ score }) => (
//   <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
//     <div
//       className={`h-full transition-all duration-500 ease-out ${
//         score >= 80 ? 'bg-success' : score >= 60 ? 'bg-warning' : 'bg-error'
//       }`}
//       style={{ width: `${score}%` }}
//     />
//   </div>
// );

// const ScoreColor = (score) => {
//   if (score >= 80) return 'text-success';
//   if (score >= 60) return 'text-warning';
//   return 'text-error';
// };

// const SubScoreRow = ({ name, score, icon }) => (
//   <div className="pl-4 border-l-2 border-border space-y-1 py-1">
//     <div className="flex items-center justify-between">
//       <div className="flex items-center gap-2">
//         <Icon name={icon} size={14} color="var(--color-muted-foreground)" />
//         <span className="text-xs text-muted-foreground">{name}</span>
//       </div>
//       <span className={`text-xs font-semibold ${ScoreColor(score)}`}>
//         {score}%
//       </span>
//     </div>
//     <ScoreBar score={score} />
//   </div>
// );

// const ExpandableSection = ({ title, icon, score, subScores, children }) => {
//   const [expanded, setExpanded] = useState(false);

//   return (
//     <div className="space-y-2">
//       <div
//         className="flex items-center justify-between cursor-pointer"
//         onClick={() => setExpanded(!expanded)}
//       >
//         <div className="flex items-center gap-2">
//           <Icon name={icon} size={16} color="var(--color-muted-foreground)" />
//           <span className="text-sm font-medium text-foreground">{title}</span>
//         </div>
//         <div className="flex items-center gap-2">
//           <span className={`text-sm font-semibold ${ScoreColor(score)}`}>
//             {score}%
//           </span>
//           <Icon
//             name={expanded ? "ChevronUp" : "ChevronDown"}
//             size={14}
//             color="var(--color-muted-foreground)"
//           />
//         </div>
//       </div>
//       <ScoreBar score={score} />
//       {expanded && (
//         <div className="space-y-2 mt-2">
//           {subScores?.map((sub, i) => (
//             <SubScoreRow
//               key={i}
//               name={sub.name}
//               score={sub.score}
//               icon={sub.icon}
//             />
//           ))}
//           {children}
//         </div>
//       )}
//     </div>
//   );
// };

// const PerformanceMetrics = ({ overallScore, categoryScores, subScores }) => {
//   const [activeTab, setActiveTab] = useState('technical');

//   const tabs = [
//     { id: 'technical',     label: 'Technical',      icon: 'Code' },
//     { id: 'softSkills',    label: 'Soft Skills',     icon: 'Heart' },
//     { id: 'problemSolving',label: 'Problem Solving', icon: 'Lightbulb' },
//   ];

//   return (
//     <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">

//       {/* Header */}
//       <div className="flex items-center gap-3 mb-6">
//         <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
//           <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
//         </div>
//         <h3 className="text-lg font-heading font-semibold text-foreground">
//           Performance Overview
//         </h3>
//       </div>

//       {/* Overall Score */}
//       <div className="mb-6">
//         <div className="flex items-center justify-between mb-3">
//           <span className="text-sm font-medium text-muted-foreground">
//             Overall Score
//           </span>
//           <span className={`text-2xl font-heading font-bold ${ScoreColor(overallScore)}`}>
//             {overallScore}%
//           </span>
//         </div>
//         <ScoreBar score={overallScore} />
//       </div>

//       {/* Tabs */}
//       <div className="flex gap-1 mb-6 bg-muted rounded-lg p-1">
//         {tabs.map((tab) => (
//           <button
//             key={tab.id}
//             onClick={() => setActiveTab(tab.id)}
//             className={`flex-1 flex items-center justify-center gap-1 px-3 py-2 rounded-md text-xs font-medium transition-all ${
//               activeTab === tab.id
//                 ? 'bg-card text-foreground shadow-sm'
//                 : 'text-muted-foreground hover:text-foreground'
//             }`}
//           >
//             <Icon name={tab.icon} size={12} />
//             {tab.label}
//           </button>
//         ))}
//       </div>

//       {/* Tab Content */}
//       <div className="space-y-4">

//         {/* Technical Tab */}
//         {activeTab === 'technical' && (
//           <div className="space-y-4">
//             {subScores?.technical?.subScores?.map((sub, i) => (
//               <div key={i} className="space-y-1">
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center gap-2">
//                     <Icon name={sub.icon} size={14} color="var(--color-muted-foreground)" />
//                     <span className="text-sm font-medium text-foreground">{sub.name}</span>
//                   </div>
//                   <span className={`text-sm font-semibold ${ScoreColor(sub.score)}`}>
//                     {sub.score}%
//                   </span>
//                 </div>
//                 <ScoreBar score={sub.score} />
//               </div>
//             ))}
//             {!subScores?.technical && categoryScores?.map((cat) => (
//               <div key={cat.id} className="space-y-1">
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center gap-2">
//                     <Icon name={cat.icon} size={14} color="var(--color-muted-foreground)" />
//                     <span className="text-sm font-medium text-foreground">{cat.name}</span>
//                   </div>
//                   <span className={`text-sm font-semibold ${ScoreColor(cat.score)}`}>
//                     {cat.score}%
//                   </span>
//                 </div>
//                 <ScoreBar score={cat.score} />
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Soft Skills Tab */}
//         {activeTab === 'softSkills' && (
//           <div className="space-y-4">
//             <ExpandableSection
//               title="Communication"
//               icon="MessageCircle"
//               score={subScores?.softSkills?.communication?.overall || 0}
//               subScores={subScores?.softSkills?.communication?.subScores}
//             />
//             <ExpandableSection
//               title="Confidence"
//               icon="Shield"
//               score={subScores?.softSkills?.confidence?.overall || 0}
//               subScores={subScores?.softSkills?.confidence?.subScores}
//             />
//             <ExpandableSection
//               title="Behavioural"
//               icon="Users"
//               score={subScores?.softSkills?.behavioural?.overall || 0}
//               subScores={subScores?.softSkills?.behavioural?.subScores}
//             />
//           </div>
//         )}

//         {/* Problem Solving Tab */}
//         {activeTab === 'problemSolving' && (
//           <div className="space-y-4">
//             {subScores?.problemSolving?.subScores?.map((sub, i) => (
//               <div key={i} className="space-y-1">
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center gap-2">
//                     <Icon name={sub.icon} size={14} color="var(--color-muted-foreground)" />
//                     <span className="text-sm font-medium text-foreground">{sub.name}</span>
//                   </div>
//                   <span className={`text-sm font-semibold ${ScoreColor(sub.score)}`}>
//                     {sub.score}%
//                   </span>
//                 </div>
//                 <ScoreBar score={sub.score} />
//               </div>
//             ))}
//           </div>
//         )}

//       </div>
//     </div>
//   );
// };

// export default PerformanceMetrics;
import React, { useState } from 'react';
import Icon from '../../../../components/AppIcon';

const ScoreBar = ({ score }) => (
  <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
    <div
      className={`h-full transition-all duration-500 ease-out ${
        score >= 80 ? 'bg-success' : score >= 60 ? 'bg-warning' : 'bg-error'
      }`}
      style={{ width: `${score}%` }}
    />
  </div>
);

const ScoreColor = (score) => {
  if (score >= 80) return 'text-success';
  if (score >= 60) return 'text-warning';
  return 'text-error';
};

const SubScoreRow = ({ name, score, icon }) => (
  <div className="pl-4 border-l-2 border-border space-y-1 py-1">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Icon name={icon} size={14} color="var(--color-muted-foreground)" />
        <span className="text-xs text-muted-foreground">{name}</span>
      </div>
      <span className={`text-xs font-semibold ${ScoreColor(score)}`}>
        {score}%
      </span>
    </div>
    <ScoreBar score={score} />
  </div>
);

const ExpandableSection = ({ title, icon, score, subScores, children }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="space-y-2">
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="flex items-center gap-2">
          <Icon name={icon} size={16} color="var(--color-muted-foreground)" />
          <span className="text-sm font-medium text-foreground">{title}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className={`text-sm font-semibold ${ScoreColor(score)}`}>
            {score}%
          </span>
          <Icon
            name={expanded ? "ChevronUp" : "ChevronDown"}
            size={14}
            color="var(--color-muted-foreground)"
          />
        </div>
      </div>

      <ScoreBar score={score} />

      {expanded && (
        <div className="space-y-2 mt-2">
          {subScores?.map((sub) => (
            <SubScoreRow
              key={sub.name}   // ✅ FIXED
              name={sub.name}
              score={sub.score}
              icon={sub.icon}
            />
          ))}
          {children}
        </div>
      )}
    </div>
  );
};

const PerformanceMetrics = ({ overallScore, categoryScores, subScores }) => {
  const [activeTab, setActiveTab] = useState('technical');

  const tabs = [
    { id: 'technical', label: 'Technical', icon: 'Code' },
    { id: 'softSkills', label: 'Soft Skills', icon: 'Heart' },
    { id: 'problemSolving', label: 'Problem Solving', icon: 'Lightbulb' },
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">

      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Performance Overview
        </h3>
      </div>

      {/* Overall Score */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm font-medium text-muted-foreground">
            Overall Score
          </span>
          <span className={`text-2xl font-heading font-bold ${ScoreColor(overallScore)}`}>
            {overallScore}%
          </span>
        </div>
        <ScoreBar score={overallScore} />
      </div>

      {/* Tabs */}
      <div className="flex gap-1 mb-6 bg-muted rounded-lg p-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}   // ✅ correct
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 flex items-center justify-center gap-1 px-3 py-2 rounded-md text-xs font-medium transition-all ${
              activeTab === tab.id
                ? 'bg-card text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon name={tab.icon} size={12} />
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="space-y-4">

        {/* Technical Tab */}
        {activeTab === 'technical' && (
          <div className="space-y-4">
            <ExpandableSection
              title="Core Technical"
              icon="Code"
              score={categoryScores?.find(cat => cat.name === 'Technical')?.score || 0}
              subScores={[
                { name: "Core Technical Skills", score: categoryScores?.find(cat => cat.name === 'Technical')?.score || 0, icon: "Code" }
              ]}
            />
            <ExpandableSection
              title="Coding"
              icon="Terminal"
              score={categoryScores?.find(cat => cat.name === 'Coding')?.score || 0}
              subScores={[
                { name: "Programming Skills", score: categoryScores?.find(cat => cat.name === 'Coding')?.score || 0, icon: "Terminal" }
              ]}
            />
          </div>
        )}

        {/* Soft Skills Tab */}
        {activeTab === 'softSkills' && (
          <div className="space-y-4">
            <ExpandableSection
              title="Communication"
              icon="MessageCircle"
              score={categoryScores?.find(cat => cat.name === 'Communication')?.score || 0}
              subScores={[
                { name: "Communication Skills", score: categoryScores?.find(cat => cat.name === 'Communication')?.score || 0, icon: "MessageCircle" }
              ]}
            />
            <ExpandableSection
              title="Confidence"
              icon="Shield"
              score={categoryScores?.find(cat => cat.name === 'Confidence')?.score || 0}
              subScores={[
                { name: "Self-Confidence", score: categoryScores?.find(cat => cat.name === 'Confidence')?.score || 0, icon: "Shield" }
              ]}
            />
            <ExpandableSection
              title="Behavioral Judgment"
              icon="Users"
              score={categoryScores?.find(cat => cat.name === 'Behavioral Judgment')?.score || 0}
              subScores={[
                { name: "Behavioral Assessment", score: categoryScores?.find(cat => cat.name === 'Behavioral Judgment')?.score || 0, icon: "Users" }
              ]}
            />
          </div>
        )}

        {/* Problem Solving Tab */}
        {activeTab === 'problemSolving' && (
          <div className="space-y-4">
            <ExpandableSection
              title="Quantitative Aptitude"
              icon="Calculator"
              score={categoryScores?.find(cat => cat.name === 'Quantitative Aptitude')?.score || 0}
              subScores={[
                { name: "Numerical Ability", score: categoryScores?.find(cat => cat.name === 'Quantitative Aptitude')?.score || 0, icon: "Calculator" }
              ]}
            />
            <ExpandableSection
              title="Logical Reasoning"
              icon="Brain"
              score={categoryScores?.find(cat => cat.name === 'Logical Reasoning')?.score || 0}
              subScores={[
                { name: "Logic Skills", score: categoryScores?.find(cat => cat.name === 'Logical Reasoning')?.score || 0, icon: "Brain" }
              ]}
            />
            <ExpandableSection
              title="Analytical Thinking"
              icon="Search"
              score={categoryScores?.find(cat => cat.name === 'Analytical Thinking')?.score || 0}
              subScores={[
                { name: "Analysis Skills", score: categoryScores?.find(cat => cat.name === 'Analytical Thinking')?.score || 0, icon: "Search" }
              ]}
            />
          </div>
        )}

      </div>
    </div>
  );
};

export default PerformanceMetrics;